var option_data_fields_arr = [];
var option_data_fields = [];

document.addEventListener("click", function (event) {
    if (event.target.matches("#bundle-choose")) {
        event.target.classList.add("hide-bundle-choose");

        var form = event.target.closest("form");
        
        // Safely check for elements before accessing them
        var boldOptionSet = form.querySelector(".bold_option_set");
        var buddleAtcBtn = form.querySelector(".buddle-atc-btn");
        
        if (boldOptionSet) {
            boldOptionSet.classList.remove("hide-bundle-choose");
        }
        if (buddleAtcBtn) {
            buddleAtcBtn.classList.remove("hide-bundle-choose");
        }
    }
});

// Collection and search bundle functionality is now handled by separate files:
// - collection-bundle-metaobject.js for collection pages
// - search-bundle-metaobject.js for search pages
// This ensures better separation of concerns and performance optimization